<template>
  <div class="container">
    <div class="row-1">
      <div
        class="btn download-btn"
        :class="{ disabled: !downloadBtnOn }"
        @click="download"
      >
        <i class="icon-wrapper">
          <iconfont
            name="#icon10-42xiazai"
            font-size="16px"
          ></iconfont>
        </i>
        {{ items.length > 1 ? '全部下载' : '立即下载' }}
      </div>
    </div>
    <div class="row-2">
      <div
        class="checkbox"
        @click="checkboxClicked"
      >
        <iconfont
          v-if="checked"
          name="#icon10-47gouxuan"
          font-szie="6px"
        ></iconfont>
      </div>
      <!-- eslint-disable -->
      <div class="text">
        <div @click="checkboxClicked" style="display: inline;cursor: pointer;">同时保存至</div>
        <a :href="activeView.materialStoreLink" target="_blank" style="margin-left: 0px;">
          <span>来画平台-我的素材-{{ activeView.materialStoreText }}</span>
        </a>
      </div>
      <!-- eslint-enable -->
    </div>
    <div class="row-3">
      <div
        class="btn btn-1"
        @click="resetEditing"
      >
        <i class="icon-wrapper">
          <iconfont
            class="inactive"
            name="#icon10-43zhongxinzhizuo"
          ></iconfont>
          <iconfont
            class="active"
            name="#icon10-43zhongxinzhizuojiaohu"
          ></iconfont> </i>重新制作
      </div>
      <a
        href="/workbench/tools"
        target="_blank"
      >
        <div class="btn btn-1">
          <i class="icon-wrapper">
            <iconfont
              class="active"
              name="#icon10-44huidaopingtaijiaohu"
            ></iconfont>
            <iconfont
              class="inactive"
              name="#icon10-44huidaopingtai"
            ></iconfont> </i>回到平台
        </div>
      </a>
    </div>

    <over-size-dialog
      v-model="dialogVisible"
      :is-poor="isOrdinaryMember"
    ></over-size-dialog>
  </div>
</template>

<script>
import FileSaver from '@/assets/scripts/FileSaver';
import { mapGetters } from 'vuex';
import JSZip from 'jszip';
import OverSizeDialog from '@/components/user/overSizeDialog';
export default {
  components: {
    OverSizeDialog
  },
  data() {
    return {
      checked: false,
      fileApi: '/upload/file',
      dialogVisible: false,
      downloadBtnOn: false,
      items: []
    };
  },
  computed: {
    ...mapGetters(['isOrdinaryMember']),
    ...mapGetters({
      views: 'views/dict',
      completed: 'completed/getFiles'
    }),
    activeView() {
      return this.views[this.$route.path.slice(1)];
    }
  },
  mounted() {
    let doing = this.$parent.$parent.doingTasks;
    doing.then(this.setDonwloadBtnOn);
    this.items = this.$parent.$parent.getItems();
  },
  methods: {
    getText() {},
    test() {
      this.dialogVisible = true;
    },
    async sizeExceeded(files) {
      let len = files.length;
      let filesSize = 0;
      for (let i = 0; i < len; i++) {
        filesSize += files[i].size;
      }
      let resp = await this.$http.get('user/material/size');
      if (resp.data.code === 200) {
        let { size: currentSize, maxSize } = resp.data.data;
        if (currentSize + filesSize > maxSize) {
          // this.$message({
          //   message: '文件超过可用空间大小，无法上传',
          //   type: 'error'
          // });
          return true;
        }
      }
      return false;
    },
    checkboxClicked() {
      this.checked = !this.checked;
    },
    resetEditing() {
      this.$store.commit('audio/clearCutAudios');
      this.$store.commit('completed/clearFiles');
      this.$store.commit('convert/clearFiles');
      this.$store.commit('merge/clearFiles');
      this.$store.commit('cropper/clearFiles');
      this.$store.commit('cutter/clearFiles');
      this.$store.commit('gif/clearGifs');
      this.$store.commit('screenshot/clearClipImages');
      this.$store.commit('videoSpeeder/clearFiles');

      this.$bus.emit('resetEditing');
      this.$modal.hide('completeModal');
    },
    getFile(url) {
      return new Promise((resolve, reject) => {
        this.$http({
          method: 'get',
          url: url,
          responseType: 'arraybuffer',
          timeout: 1000 * 60 * 60
        })
          .then((data) => {
            if (data.status === 200 && data.data) {
              resolve(data.data);
            } else {
              throw 'download error';
            }
          })
          .catch((error) => {
            reject(error.toString());
          });
      });
    },
    async download() {
      if (!this.downloadBtnOn) {
        return;
      }
      let items = this.$parent.$parent.getItems();
      this.$sensors.track('toolDownload', {
        tool_type: (this.activeView || {}).text || '',
        content_number: items.length || 0,
        is_save: this.checked || false
      });
      if (items.length === 1) {
        let item = items[0];
        FileSaver.saveAs(item.url, item.name);
      } else if (items.length > 1) {
        const zip = new JSZip();
        let tasks = items.map((item) => {
          let _url = item.origin.blob;
          if (_url instanceof Blob) {
            zip.file(item.name, _url, { binary: true });
            return Promise.resolve();
          }
          return this.getFile(item.url).then((data) => {
            zip.file(item.name, data, { binary: true });
          });
        });
        Promise.all(tasks).then(() => {
          zip.generateAsync({ type: 'blob' }).then((content) => {
            FileSaver.saveAs(content, '文件集合.zip');
          });
        });
      }

      if (this.checked) {
        let isExceeded = await this.sizeExceeded(items);
        if (isExceeded) {
          this.dialogVisible = true;
        } else {
          this.storeMaterials();
        }
      }
    },
    storeMaterials() {
      let viewName = this.$route.path.slice(1);
      let view = this.views[viewName];
      let { materialType = '' } = view;
      if (materialType) {
        let methodName = 'store' + materialType[0].toUpperCase() + materialType.slice(1) + 'Materials';
        typeof this[methodName] === 'function' && this[methodName]({ view });
      }
    },
    storeImageMaterials({ view = {} } = {}) {
      let items = this.$parent.$parent.getItems();
      for (let item of items) {
        if (item.size > 200 * 1024 * 1024) {
          this.$message({
            message: '由于素材大小限制，视频大于200M无法保存至素材库',
            type: 'error'
          });
        } else if (typeof item.cover === 'string') {
          this.$http
            .post(view.materialApi, {
              url: this.$.unhandleAssetsUrl(item.url),
              thumbnailUrl: this.$.unhandleAssetsUrl(item.cover),
              title: item.name
            })
            .then((res) => {
              res;
            });
        } else {
          this.uploadFile(this.fileApi, item.cover || item.origin.blob || '').then((res) => {
            let file = res.data.data;
            this.$http
              .post(view.materialApi, {
                url: this.$.unhandleAssetsUrl(file.filename),
                thumbnailUrl: this.$.unhandleAssetsUrl(file.thumbnailName),
                title: item.name
              })
              .then((res) => {
                res;
              });
          });
        }
      }
    },
    storeVideoMaterials({ view = {} } = {}) {
      let items = this.$parent.$parent.getItems() || [];
      if (this.$route.path === '/videoConverter') {
        let originItems = items;
        items = items.filter((v) => (v.origin || {}).outputFormat === 'MP4');
        if (items.length < originItems.length) {
          this.$message({
            message: '非MP4格式的视频不支持保存到平台哦',
            type: 'error'
          });
        }
      }
      for (let item of items) {
        if (typeof item.cover === 'string') {
          this.$http
            .post(view.materialApi, {
              url: this.$.unhandleAssetsUrl(item.url),
              thumbnailUrl: this.$.unhandleAssetsUrl(item.cover),
              title: item.name,
              times: item.duration,
              duration: item.duration,
              fileType: 26,
              gop: item.duration < 60 ? 1 : 0
            })
            .then((res) => {
              res;
            });
        } else {
          this.uploadFile(this.fileApi, item.cover).then((res) => {
            let file = res.data.data || {};
            this.$http
              .post(view.materialApi, {
                url: this.$.unhandleAssetsUrl(item.url),
                thumbnailUrl: this.$.unhandleAssetsUrl(file.filename),
                title: item.name,
                times: item.duration,
                duration: item.duration,
                fileType: 26,
                gop: item.duration < 60 ? 1 : 0
              })
              .then((res) => {
                res;
              });
          });
        }
      }
    },
    storeAudioMaterials({ view = {} } = {}) {
      let items = this.$parent.$parent.getItems();
      for (let item of items) {
        this.$http
          .post(view.materialApi, {
            url: this.$.unhandleAssetsUrl(item.url),
            title: item.name,
            times: item.duration,
            duration: item.duration,
            fileType: 26
          })
          .then((res) => {
            res;
          });
      }
    },
    postMaterials({ fileApi = '/upload/file', materialApi = '/user/pic' }) {
      let items = this.$parent.$parent.getItems();
      for (let item of items) {
        this.uploadFile(fileApi, item.origin.blob).then((res) => {
          let file = res.data.data;
          this.$http
            .post(materialApi, {
              url: file.filename,
              thumbnailUrl: file.thumbnailName,
              title: item.name
            })
            .then((res) => {
              res;
            });
        });
      }
    },
    uploadFile(url, data) {
      let p = new Promise((resolve, reject) => {
        var formData = new FormData();
        formData.append('files[]', data);
        this.$http({
          url: url,
          method: 'post',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data; boundary=---12321' },
          // cancelToken: this.source.token,
          onUploadProgress: () => {
            // 属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
          }
        })
          .then((res) => {
            resolve(res);
          })
          .catch(() => {
            reject(false);
          });
      });
      return p;
    },
    setDonwloadBtnOn() {
      this.downloadBtnOn = true;
    },
    setDonwloadBtnOff() {
      this.downloadBtnOn = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 480px;
  padding-top: 24px;
  padding-bottom: 34px;
  // margin-left: auto;
  // margin-right: auto;
  background-color: #fff;
  user-select: none;
  background-color: #fff;
}
.row-1,
.row-2,
.row-3 {
  width: 400px;
  margin-left: auto;
  margin-right: auto;
}
.row-2 {
  width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 24px;
  & > .text {
    font-size: 12px;
    & /deep/ span {
      color: #2f58fe;
    }
  }
}
.row-3 {
  width: 400px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
}
.download-btn {
  width: 399px;
  height: 50px;
  background: #2f58fe;
  border-radius: 4px;
  color: #fff;
  &:hover {
    background-color: #3d7dff;
  }
  & .icon-wrapper {
    margin-right: 5px;
  }
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
.btn-1 {
  width: 186px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #d5d5d5;
  border-radius: 4px;
  color: #333333;
  &:hover {
    color: #2f58fe;
    border-color: #2f58fe;
  }
  & .icon-wrapper {
    margin-right: 5px;
    & > .active {
      display: none;
    }
    & > .inactive {
      display: inline-block;
    }
  }
}
.btn-1:hover {
  & .icon-wrapper {
    & > .active {
      display: inline-block;
    }
    & > .inactive {
      display: none;
    }
  }
}
// .btn-2 {
//   width: 186px;
//   height: 40px;
//   background: #ffffff;
//   border: 1px solid  #d5d5d5;
//   border-radius: 4px;
//   color: #333333;
//   &:hover {
//     color: #2f58fe;
//     border-color:  #2f58fe;
//   }
//   & .icon-wrapper {
//     margin-right: 5px;
//   }
// }
.checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 6px;
  cursor: pointer;
  width: 12px;
  height: 12px;
  background: #ffffff;
  border: 1px solid #666666;
  border-radius: 2px;
  & > svg {
    transform: scale(0.8);
  }
}
</style>
